// extracted by mini-css-extract-plugin
export default {"video-link":"l_bc d-flex align-items-center my-2","video-link__link":"l_bd ml-2"};